export class Search {
	static readonly type = '[mortgageBrokerageSearch] search';
	constructor(public searchTerm: string) {}
}
